module.exports = __webpack_public_path__ + "./assets/img/step1.ea7f7809.svg";